import React from 'react';
import { TextField, Button, Box } from "@mui/material";
import { BaseTools } from "./BaseTools";
import { isMobile } from "../App/utils";
import { mobileButton } from "../App/theme";

export const IndexedDBTools = (params) => {
    const {
        setSelectMode, embeddingConfigured, setDevMode, selectedItems, items, handleDeleteSelected, exclusiveStartKeyHistory,
        handleLimitChange, handleNextPage, handlePreviousPage, selectMode, devMode, limit, lastEvaluatedKey,
        setFrom, setTo, setField, field, from, to, KBData, debouncedHandleSearch, handleSearchOnEnter,
        stores, store, setStore, index, setIndex, itemsIndexedDB, setSystemAlert, setLoading
    } = params;

    const {FetchItems, ...restParams} = params;

    return (
        <>
            <BaseTools {...restParams} isIndexedDB={true} />

            {embeddingConfigured && itemsIndexedDB !== null && KBData?.embeddingModel && (
                <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} alignItems="center" gap={2} mb={3}>
                    <TextField
                        label={`Search by meaning`}
                        variant="outlined"
                        fullWidth={isMobile}
                        onChange={(e) => debouncedHandleSearch(e.target.value)}
                        onKeyPress={(e) => {
                            handleSearchOnEnter(e)
                        }}
                        size={"small"}
                        InputProps={{ style: { height: '40px' } }}
                        sx={{ flex: isMobile ? '1 1 100%' : '2 1 50%' }}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={FetchItems}
                        sx={{ maxHeight: 40, width: isMobile ? '100%' : '20%', ...mobileButton, marginTop: 0 }}
                    >
                        Search
                    </Button>

                </Box>
            )}


        </>
    );
}